<template>
  <!--
        不需要打印的内容加上：class="noprint"
        // 使用div包裹需要分页的块 使用 css属性 page-break-after:always进行分页
    -->
  <el-dialog
    :visible.sync="dialogVisible"
    append-to-body
    top="2vh"
    v-loading="loading"
    style="padding: 0px;"
    width="60%">
    <div id="printBox" ref="print" class="result">
      <div
        style="
          font-size: 30px;
          font-weight: 600;
          color: #000;
          margin-bottom: 20px;
          width: 100%;text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;
        "
      >
        志愿报告
      </div>
      <div
        style="
          font-size: 22px;
          font-weight: 600;
          color: #444;
          margin-bottom: 20px;
          padding-top: 20px;
        ">
        一、高考成绩信息
      </div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-size: 18px">考生基础信息</span>
        </div>
        <el-row>
          <el-col :span="8" style="font-size: 14px">
            <span style="font-weight: bold">姓名：</span>
            {{ $parent.detail.name }}
          </el-col>
          <el-col :span="8" style="font-size: 14px">
            <span style="font-weight: bold">性别：</span>
            {{ $parent.detail.sex == 1 ? "男" : "女" }}
          </el-col>
          <el-col :span="8" style="font-size: 14px">
            <span style="font-weight: bold">省份：</span>
            {{ $parent.detail.province }}
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="8" style="font-size: 14px">
            <span style="font-weight: bold">文理：</span>
            {{ $parent.detail.group_d }}
          </el-col>
          <el-col :span="8" style="font-size: 14px">
            <span style="font-weight: bold">高中：</span>
            {{ $parent.detail.seniorHighSchool }}
          </el-col>
          <el-col :span="8" style="font-size: 14px">
            <span style="font-weight: bold">班级：</span>
            --
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card" style="margin-top: 30px">
        <div slot="header" class="clearfix">
          <span style="font-size: 18px">高考成绩信息</span>
        </div>
        <el-row>
          <el-col :span="8" style="font-size: 14px">
            <span style="font-weight: bold">成绩：</span>
            {{ $parent.detail.score }}分
          </el-col>
          <el-col :span="8" style="font-size: 14px">
            <span style="font-weight: bold">位次：</span>
            {{ $parent.detail.paiming }}位
          </el-col>
          <el-col :span="8" style="font-size: 14px">
            <span style="font-weight: bold">与你同分人数：</span>
            {{ $parent.detail.xiangtong }}人
          </el-col>
        </el-row>
      </el-card>
      <el-card
        class="box-card"
        style="margin-top: 30px; page-break-after: always">
        <div slot="header" class="clearfix">
          <span style="font-size: 18px">全省位次折线图</span>
        </div>
        <div
          id="mapContainer"
          style="width: 100%; margin: 0 auto; height: 500px"></div>
      </el-card>
      <el-card class="box-card" style="margin-top: 30px">
        <div slot="header" class="clearfix">
          <span style="font-size: 18px">分数相同人数分析图</span>
        </div>
        <div
          id="scoreContainer"
          style="width: 100%; margin: 0 auto; height: 450px"></div>
      </el-card>
      <div
        style="
          font-size: 22px;
          font-weight: 600;
          color: #444;
          margin-bottom: 20px;
          padding-top: 20px;
        ">
        二、志愿单预览
      </div>
      <div style="width: 100%">
        <tableVue
          :form="form"
          :activeName="String($parent.activeName)"
          ref="tableDatas"
          :lists="list" />
      </div>
      <!-- <div
        style="
          font-size: 22px;
          font-weight: 600;
          color: #444;
          margin-bottom: 20px;
          padding-top: 20px;
        "
      >
      三、其它说明
      </div>
      <el-card class="box-card" style="margin-top: 30px;">
        <div>
            <span style="font-weight: bold;">关于录取百分位的说明：</span>
            为了能够更为精确的预测高校录取成绩，我们采用了录取百分位作为测算指标，将历年数据通过大量科学运算分析得到次年的预测值.
        </div>
        <div style="margin-top: 30px;line-height: 30px;">
            <span style="font-weight: bold;">数据分析方法：</span>
            为了避免高考题目难易程度对整体分数高低的影响，系统首先将分数换算为对应位次，然后采用各批次省控线所对应的累计人数作为参考点，通过多重复杂的科学运算求得录取百分位。
        </div>
      </el-card>
      <div
        style="
          font-size: 22px;
          font-weight: 600;
          color: #444;
          margin-bottom: 20px;
          padding-top: 20px;
        "
      >
      四、结  语
      </div>
      <el-card class="box-card" style="margin-top: 30px;">
        <div style="line-height: 30px;">
            当然，无论怎样，我们只能帮你更好的全面客观的认识自己，让你知道自己擅长做些什么？适合做些什么？喜欢做些什么？而打开成功之门的钥匙，掌握在你的手中。
        </div>
      </el-card>
      <div
        style="
          font-size: 22px;
          font-weight: 600;
          color: #444;
          margin-bottom: 20px;
          padding-top: 20px;
        "
      >
      五、附  录
      </div>
      <el-card class="box-card" style="margin-top: 30px;">
        <div style="line-height: 30px;">
            本报告是运用启程志愿AI云数据高考志愿导航系统生成的。在理解报告内容时，必须考虑到以问卷为基础之评价的主观特性。启程志愿科技有限公司对使用此份报告的后果不承担责任。
        </div>
      </el-card> -->
      <div
        style="
          font-size: 22px;
          font-weight: 600;
          color: red;
          margin-bottom: 20px;
          padding-top: 20px;
        ">
        三、免责声明
      </div>
      <el-card
        class="box-card"
        style="margin-top: 30px; page-break-after: always">
        <div style="line-height: 30px; color: red">
          1、启程志愿通过大量数据分析出学生的专业及兴趣方向，并依据测评结果推荐学生报考院校及专业。因由国家教育考试院历年数据提取，且考虑到“大小年、冷热门、报考扎堆”等不确定因素，所有服务项目仅提供高考志愿填报参考，考生及家长须结合自身多方面情况，以自主自愿原则，慎重报读志愿和专业，对于报考结果出现的任何相关问题，启程志愿不承担任何法律责任。
        </div>
        <div style="line-height: 30px; margin-top: 30px; color: red">
          2、本报告为您推荐了各批次各等级志愿填报的参考院校，可为高考志愿填报的院校选择提供参考，但不能作为唯一依据。应该与其它有关信息，如考生高考成绩排名、往年各院校录取考生排名、各院校招生人数变化等结合使用。本报告结果注意保密，只供使用者与其家属阅读。
        </div>
        <div style="line-height: 30px; margin-top: 30px; color: red">
          3、备注：本报告中的院校代码、专业代码仅为参考，本报告中的院校代码、专业代码需考生按照本省招生计划核对，进行填报！
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 30px">
        <div style="width: 100%; display: flex">
          <div class="neirong01" style="display: flex; flex-direction: column">
            更多内容可扫描下方二维码浏览访问
            <img
              style="width: 294px; height: 294px; margin-top: 20px"
              :src="qrcodeImage"
              ref="qrcode_canvas"
              alt="" />
          </div>
          <div style="margin-left: auto; margin-right: 50px">
            <div style="display: flex; align-items: center">
              签名：
              <div
                style="
                  height: 30px;
                  width: 240px;
                  border-bottom: 1px solid rgb(222, 226, 230) !important;
                "></div>
            </div>
            <div style="display: flex; align-items: center; margin-top: 30px">
              <div
                style="
                  height: 30px;
                  width: 103px;
                  border-bottom: 1px solid rgb(222, 226, 230) !important;
                "></div>
              年
              <div
                style="
                  height: 30px;
                  width: 68px;
                  border-bottom: 1px solid rgb(222, 226, 230) !important;
                "></div>
              月
              <div
                style="
                  height: 30px;
                  width: 68px;
                  border-bottom: 1px solid rgb(222, 226, 230) !important;
                "></div>
              日
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click="dayin">打印</el-button>
      <el-button type="danger" @click="dialogVisible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as echarts from "echarts";
import { getOnequarter, college_intell_screen, college_gaoxiao_screen, college_result_screen } from "@/api/gw/volunteer.js";
import html2canvas from "html2canvas";
import tableVue from "./tables.vue";
import jrQrcode from "jr-qrcode"
export default {
  components: {
    tableVue,
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {}, // 报告中使用的基本信息（年份等）
      printObj: {
        id: "printBox", // 必要，打元素的id
        popTitle: "志愿报告", // 打印配置页上方标题
        extraHead: "", //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
        preview: "", // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
        previewTitle: "志愿报告", // 打印预览的标题（开启预览模式后出现）,
        previewPrintBtnLabel: "", // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
        zIndex: "9999999999", // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
        previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
        previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
        beforeOpenCallback() {}, // 开启打印前的回调事件
        openCallback() {}, // 调用打印之后的回调事件
        closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
        url: "",
        standard: "",
        extraCss: "",
      },
      myChart: null,
      myCharts: null,
      seat: [],
      score_num: [],
      img: "",
      list: [], // 报告中使用的所有数据
      dates: 1,
      qrcodeImage: "",
      qrSize: 294,
    };
  },
  props: {},
  mounted() {},
  methods: {
    show() {
      this.$nextTick(() => {
        this.dialogVisible = true;
        setTimeout(() => {
          this.creatQrCode(); //转二维码
        }, 500);
        this.getOnequarter();
        this.loadAllData(); // 加载所有数据用于报告
      });
    },
    // 加载所有志愿数据（不分页）
    loadAllData() {
      this.loading = true;
      const activeName = this.$parent.activeName;
      const volunteerId = this.$parent.detail.volunteer_id;
      
      let apiCall = null;
      
      if (activeName == 1) {
        // 智能筛选
        apiCall = college_intell_screen({
          aspid: volunteerId,
          up_score: this.$parent.value1,
          down_score: this.$parent.value2,
          page: 1,
          pageSize: 10000 // 加载所有数据
        });
      } else if (activeName == 2 || activeName == 3) {
        // 高校筛选
        let form = activeName == 2 ? {...this.$parent.collForm} : {...this.$parent.collForm3};
        form["aspid"] = volunteerId;
        form["shouciZhao"] = activeName == 3 ? "是" : "";
        form["page"] = 1;
        form["pageSize"] = 10000; // 加载所有数据
        apiCall = college_gaoxiao_screen(form);
      } else if (activeName == 4) {
        // 查看结果
        let form = {...this.$parent.resultForm};
        form["aspid"] = volunteerId;
        form["page"] = 1;
        form["pageSize"] = 10000; // 加载所有数据
        apiCall = college_result_screen(form);
      }
      
      if (apiCall) {
        apiCall.then(res => {
          this.list = res.data.list || [];
          // 更新form数据（年份等信息）
          if (res.data.object) {
            this.$set(this, 'form', res.data.object);
          }
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    creatQrCode() {
      let bQrUrl =
        "https://www.qichengzhiyuan.cn/H5/#/pages/zhineng/baogao?volunteer_id=" +
        this.$parent.detail.volunteer_id;
        var imgBase64 = jrQrcode.getQrBase64(bQrUrl); //生成二维码
        this.qrcodeImage = imgBase64
    },
    getOnequarter() {
      getOnequarter({
        aspid: this.$parent.detail.volunteer_id,
      }).then((res) => {
        console.log("折线图", res.data);
        this.seat = res.data.seat;
        this.score_num = res.data.score_num;
        this.readMap();
        this.readTong();
      });
    },
    dayin() {
      this.$print(this.$refs.print);
      this.$nextTick(() => {
        let arr = document.getElementsByClassName("isNeedRemove");
        if (this.myCharts != null) {
          this.myCharts.dispose(); // 清理 ECharts 实例
          this.readTong();
        }
        if (arr.length) {
          arr[0].remove();
        }
      });
    },
    readMap() {
      let that = this;
      if (!this.seat || this.seat.length === 0) return;
      
      // 获取排名（X轴）的最大值和最小值
      const seatValues = this.seat.map(item => parseInt(item[0]));
      const maxSeat = Math.max(...seatValues);
      const minSeat = Math.min(...seatValues);
      
      // 获取分数（Y轴）的最大值和最小值
      const scoreValues = this.seat.map(item => parseInt(item[1]));
      const maxScore = Math.max(...scoreValues);
      const minScore = Math.min(...scoreValues);
      
      // 计算合适的坐标轴范围
      const seatRange = maxSeat - minSeat;
      const scoreRange = maxScore - minScore;
      
      //初始化echarts实例
      this.myChart = echarts.init(document.getElementById("mapContainer"));
      var option = {
        xAxis: {
          type: "value",
          name: "排名",
          min: 0,
          max: Math.ceil(maxSeat / 10000) * 10000, // 向上取整到万位
          interval: Math.ceil(maxSeat / 5 / 1000) * 1000, // 分为5段，向上取整到千位
        },
        yAxis: { 
          type: "value", 
          name: "分数", 
          min: Math.floor(minScore / 50) * 50, // 向下取整到50的倍数
          max: Math.ceil(maxScore / 50) * 50, // 向上取整到50的倍数
          interval: 50 
        },
        series: [
          {
            data: this.seat,
            type: "line",
            symbol: "none",
            smooth: true,
            markPoint: {
              symbol: "pin", // 标记点形状为圆形
              symbolSize: 50, // 标记点大小为10px
              data: [
                {
                  name: "您在这里",
                  value: "您在这里",
                  xAxis: this.$parent.detail.paiming,
                  yAxis: Number(this.$parent.detail.score),
                },
              ], // 初始化标记点数组为空
            },
          },
        ],
      };

      //使用制定的配置项和数据显示图表
      this.myChart.setOption(option);
    },
    readTong() {
      let that = this;
      if (!this.score_num || this.score_num.length === 0) return;
      
      // 获取人数（Y轴）的最大值
      const maxPeople = Math.max(...this.score_num.map(item => item[1]));
      
      // 获取分数（X轴）的最大值和最小值
      const scoreValues = this.score_num.map(item => item[0]);
      const maxScore = Math.max(...scoreValues);
      const minScore = Math.min(...scoreValues);
      
      var option = {
        xAxis: { 
          type: "value", 
          name: "分数", 
          min: Math.floor(minScore / 50) * 50, // 向下取整到50的倍数
          max: Math.ceil(maxScore / 50) * 50, // 向上取整到50的倍数
          interval: 50 
        },
        yAxis: {
          type: "value",
          name: "人数",
          min: 0,
          max: Math.ceil(maxPeople / 100) * 100, // 向上取整到100的倍数
          interval: Math.ceil(maxPeople / 5 / 100) * 100, // 分为5段，向上取整到100的倍数
        },
        series: [
          {
            data: this.score_num,
            type: "line",
            symbol: "none",
            smooth: 0.5,
            markPoint: {
              symbol: "pin", // 标记点形状为圆形
              symbolSize: 50, // 标记点大小为10px
              data: [
                {
                  name: "您在这里",
                  value: "您在这里",
                  xAxis: Number(that.$parent.detail.score),
                  yAxis: that.$parent.detail.xiangtong, //相同的人数
                },
              ], // 初始化标记点数组为空
            },
          },
        ],
      };
      //初始化echarts实例
      this.myCharts = echarts.init(document.getElementById("scoreContainer"));
      //使用制定的配置项和数据显示图表
      this.myCharts.setOption(option);
    },
  },
};
</script>
<style media="print" lang="scss" scoped>
.result {
  width: 96%;
  margin: 2%;
  height: 70vh;
  overflow-y: scroll;
}
@page {
  size: auto A4 landscape;
  margin: 20px auto;
}

html {
  height: auto;
}
.tables {
  width: 100%;
  display: flex;
  padding-top: 15px;
  padding-bottom: 15px;
}
.tables:nth-child(2n) {
  background: #f5fbff;
}
</style>
<style>
.procedure {
  word-wrap: break-word;
}
</style>
<style lang="scss" scoped>
.inner::-webkit-scrollbar {
  display: none;
}
.isNeedRemove {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/volunteer/components/baogao.vue